export const LESSON_DATA_QUERY_KEY = "lessonData";
export const WATER_DROPLETS_QUERY_KEY = "waterDroplets";
export const USER_STATS_QUERY_KEY = "userStats";
export const DICTIONARY_STATS_QUERY_KEY = "dictionaryStats";
export const CARDS_QUERY_KEY = "reviewCards";
